export const TEXT_PANEL_TOOLTIPS = [
  {
    id: 'text-font-family',
    cookieKey: 'editor_tip_text_font_family',
    title: 'Choose a font',
    description: 'Try different fonts to match the style you want.',
    placement: 'top',
    align: 'center',
    delayAfterClose: 1500,
  },
  {
    id: 'text-colour',
    cookieKey: 'editor_tip_text_colour',
    title: 'Change text colour',
    description: 'Pick a colour that stands out clearly against your image.',
    placement: 'top',
    align: 'center',
    delayAfterClose: 1500,
  },
  {
    id: 'text-shadow',
    cookieKey: 'editor_tip_text_shadow',
    title: 'Add an effect',
    description:
      'Add a shadow or outline to help your text stand out more clearly.',
    placement: 'top',
    align: 'center',
    delayAfterClose: 1500,
  },
];
